export default "__VITE_ASSET__RIefa2kO__"